import { useTranslation } from "react-i18next";
import { minOrder, packSize, unitLabel } from "@/lib/product";

/** "per 6 stuks · minimaal 12" — alleen als het CRM deze velden levert. */
export const PackagingHint = ({ product, testId = "packaging-hint" }) => {
  const { t, i18n } = useTranslation();
  const pack = packSize(product);
  const min = minOrder(product);
  if (!pack && !min) return null;
  const eenheidLabel = unitLabel(product?.eenheid || t("cart.pieces"), pack || min, i18n.language);
  const delen = [];
  if (pack) delen.push(t("cart.packStep", { aantal: pack, eenheid: eenheidLabel }));
  if (min) delen.push(t("cart.packMin", { aantal: min }));
  return (
    <p className="mt-1 text-xs text-muted-foreground" data-testid={testId}>
      {delen.join(" · ")}
    </p>
  );
};
